module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Identificação \n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" "), (_vm.type == 'reset') ? [_vm._v("Esqueci minha senha")] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._v("Desbloqueio de conta")] : _vm._e(), _vm._v(" "), (_vm.type == 'login') ? [_vm._v("Autenticação de 2 fatores")] : _vm._e()], 2), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), (_vm.type == 'reset') ? _c('p', [_vm._v("Informe seu "), _c('b', [_vm._v("telefone celular")]), _vm._v(" ou "), _c('b', [_vm._v("e-mail")]), _vm._v(" cadastrado em sua conta para redefinir a senha.")]) : _vm._e(), _vm._v(" "), (_vm.type == 'login') ? _c('div', [_c('p', [_vm._v("Escolha um dos canais para receber o código de autenticação.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t80"
  }, [(_vm.formState == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" "), _vm._v("\n              As orientações para redefinir sua senha foram enviadas para o e-mail ou telefone cadastrado.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "chooseChannel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    attrs: {
      "id": "chooseEmailId",
      "type": "radio",
      "value": "email",
      "name": "chooseChannelForm"
    },
    domProps: {
      "checked": _vm._q(_vm.channelSelected, "email")
    },
    on: {
      "change": function($event) {
        _vm.channelSelected = "email"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    attrs: {
      "id": "chooseCellphoneId",
      "type": "radio",
      "value": "cellphone",
      "name": "chooseChannelForm"
    },
    domProps: {
      "checked": _vm._q(_vm.channelSelected, "cellphone")
    },
    on: {
      "change": function($event) {
        _vm.channelSelected = "cellphone"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chooseCellphoneId"
    }
  }, [_vm._v("Celular")]), _vm._v(" "), (_vm.channelSelected == 'email') ? _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Digite seu E-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFilter(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.channelSelected == 'cellphone') ? _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cellphone),
      expression: "cellphone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cellphone",
      "placeholder": "Digite seu Telefone",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.cellphone)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFilter(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cellphone = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-purple",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0bb7230a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/choose-channel.vue
// module id = 2043
// module chunks = 1